import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useCart } from "./CartContext";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const BoulangerieItems = () => {
  const { ownerId } = useParams();
  const ownerData = ownerId;
  const [userId, setUserId] = useState("");
  const [categoriesWithItems, setCategoriesWithItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { addToCart, cart, removeFromCart } = useCart();
  const navigate = useNavigate();
  const categoryListRef = useRef(null);

  const [deliveryAddress, setDeliveryAddress] = useState("");

  const restaurantName = "La Petite Boulangerie";
  const restaurantRating = 4.5;
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserId(decodedToken.userId);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/items/${ownerId}`);
        setCategoriesWithItems(response.data.items);
        console.log("Fetched data:", response.data.items);
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };

    fetchItems();
  }, [ownerId]);

  const handleAddToCart = (item) => {
    addToCart({
      _id: item._id,
      itemName: item.itemName,
      itemImg: item.itemImg,
      price: item.price,
      freshlyBaked: item.freshlyBaked || false,
      quantity: 1,
      ownerId: ownerData,
      userId: userId,
      category: item.category,
    });
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const calculateTotal = () => {
    const subtotal = cart.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
    return subtotal.toFixed(2);
  };

  const getUniqueCategories = () => {
    return categoriesWithItems.map((cat) => cat.category);
  };

  const uniqueCategories = getUniqueCategories();

  const getItemsByCategory = (category) => {
    const categoryObject = categoriesWithItems.find(
      (cat) => cat.category === category
    );
    return categoryObject ? categoryObject.items : [];
  };

  const isMobileView = () => {
    return window.innerWidth <= 768; // Example breakpoint for mobile
  };

  return (
    <div className="main-container">
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="header-logo">Lememeprix</div>
            <div className="header-actions">
              <div className="location-input">
                <i className="fa-solid fa-location-dot"></i>
               
              </div>
              <div className="header-buttons">
                <button className="cart-button">
                  <i className="fa-solid fa-cart-shopping"></i>
                  <span className="cart-count">{cart.length}</span>
                </button>
                <button className="user-button">
                  <i className="fa-regular fa-user"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="main-content">
        <section className="hero-section">
          <img
            className="hero-image"
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/7183815703-480a1131b86381c40c2d.png"
            alt="bakery interior"
          />
          <div className="hero-overlay">
            <div className="container">
              <h1 className="hero-title">La Petite Boulangerie</h1>
            </div>
          </div>
        </section>

        <section className="menu-section">
          <div className="container">
            <div className="menu-container">
              <div
                className={`category-list ${
                  isMobileView() ? "horizontal-scroll" : "vertical-scroll"
                }`}
              >
                <ul>
                  {uniqueCategories.map((category) => (
                    <li
                      key={category}
                      className={selectedCategory === category ? "active" : ""}
                      onClick={() => handleCategoryClick(category)}
                    >
                      {category}
                    </li>
                  ))}
                </ul>
              </div>

              <div
                className={`menu-grid ${
                  isMobileView() ? "vertical-list" : "horizontal-list"
                }`}
              >
                {selectedCategory
                  ? getItemsByCategory(selectedCategory).map((item) => (
                      <div key={item._id} className="menu-card">
                        <img
                          className="menu-card-image"
                          src={item.itemImg}
                          alt={item.itemName}
                        />
                        <div className="menu-card-details">
                          <h3 className="food-title">{item.itemName}</h3>
                          <p className="food-price">€{item.price}</p>
                          <button
                            className="add-to-cart"
                            onClick={() => handleAddToCart(item)}
                          >
                            <i className="fa-solid fa-plus"></i> Ajouter
                          </button>
                        </div>
                      </div>
                    ))
                  : categoriesWithItems.map((categoryObject) =>
                      categoryObject.items.map((item) => (
                        <div key={item._id} className="menu-card">
                          <img
                            className="menu-card-image"
                            src={item.itemImg}
                            alt={item.itemName}
                          />
                          <div className="menu-card-details">
                            <h3 className="food-title">{item.itemName}</h3>
                            <p className="food-price">€{item.price}</p>
                            <button
                              className="add-to-cart"
                              onClick={() => handleAddToCart(item)}
                            >
                              <i className="fa-solid fa-plus"></i> Ajouter
                            </button>
                          </div>
                        </div>
                      ))
                    )}
              </div>
            </div>
          </div>
        </section>

        <div className="floating-cart">
          <button className="cart-button" onClick={() => navigate("/cart")}>
            <i className="fa-solid fa-cart-shopping"></i>
            Voir le panier ({cart.length} articles) - €{calculateTotal()}
          </button>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4 className="footer-title">Liens rapides</h4>
              <ul className="footer-links">
                <li>
                  <span className="footer-link">À propos de nous</span>
                </li>
                <li>
                  <span className="footer-link">Contact</span>
                </li>
                <li>
                  <span className="footer-link">
                    Politique de confidentialité
                  </span>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-title">Suivez-nous</h4>
              <div className="social-icons">
                <span className="social-icon">
                  <i className="fa-brands fa-facebook"></i>
                </span>
                <span className="social-icon">
                  <i className="fa-brands fa-instagram"></i>
                </span>
                <span className="social-icon">
                  <i className="fa-brands fa-twitter"></i>
                </span>
              </div>
            </div>
            <div className="footer-section">
              <h4 className="footer-title">Assistance</h4>
              <div className="contact-info">
                <p>Besoin d'aide ? Contactez-nous :</p>
                <div className="contact-details">
                  <i className="fa-solid fa-phone"></i>
                  <span>+33 1 23 45 67 89</span>
                </div>
                <div className="contact-details">
                  <i className="fa-solid fa-envelope"></i>
                  <span>support@lememeprix.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <style jsx>{`
        .main-container {
          min-height: 100vh;
          background-color: #f9fafb;
        }

        .header {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          background-color: #fff;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          z-index: 50;
        }

        .header .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .header-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem;
        }

        .header-logo {
          font-size: 1.5rem;
          font-weight: bold;
        }

        .location-input {
          position: relative;
          flex: 1;
          margin: 0 1rem;
        }

        .location-input i {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #6b7280;
        }

        .location-input input {
          width: 100%;
          padding: 0.5rem 1rem;
          padding-left: 3rem;
          border: 1px solid #e5e7eb;
          border-radius: 0.5rem;
          outline: none;
        }

        .location-input input:focus {
          border-color: #000;
        }

        .header-buttons {
          display: flex;
          gap: 1rem;
        }

        .header-actions {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .header-actions button {
          color: #4b5563;
          transition: color 0.2s ease;
          background: none;
          border: none;
          cursor: pointer;
        }

        .header-actions button:hover {
          color: #1f2937;
        }

        .main-content {
          padding-top: 5rem;
        }

        .hero-section {
          position: relative;
          height: 400px;
        }

        .hero-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background-color: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hero-title {
          font-size: 3rem;
          font-weight: bold;
          color: #fff;
          text-align: center;
        }

        .menu-section {
          padding: 2rem 0;
        }

        .menu-container {
          display: flex;
          flex-direction: column;
        }

        /* Styles for larger screens (tablets and above) */
        @media (min-width: 769px) {
          .menu-container {
            flex-direction: row; /* Horizontal layout */
          }
        }

        .category-list {
          width: 100%;
          margin-bottom: 1rem;
        }

        .category-list ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
        }

        .category-list li {
          padding: 10px;
          cursor: pointer;
          border-bottom: 1px solid #eee;
          white-space: nowrap; /* Prevent text from wrapping */
          transition: background-color 0.2s;
        }

        .category-list li:hover {
          background-color: #f0f0f0;
        }

        .category-list li.active {
          background-color: #e0e0e0;
          font-weight: bold;
        }

        .category-list.horizontal-scroll ul {
          display: flex;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-snap-type: x mandatory;
          scrollbar-width: none; /* Hide scrollbar in Firefox */
        }

        .category-list.horizontal-scroll ul::-webkit-scrollbar {
          display: none; /* Hide scrollbar in Chrome, Safari, and Edge */
        }

        .category-list.horizontal-scroll li {
          border-bottom: none;
          border-right: 1px solid #eee; /* Add a divider between categories */
          scroll-snap-align: start;
        }

        .category-list.vertical-scroll {
          width: 200px;
          height: 400px;
          overflow-y: auto;
        }

        .menu-grid {
          display: grid;
          gap: 1.5rem;
        }

        .menu-grid.vertical-list {
          grid-template-columns: repeat(1, 1fr);
        }

        .menu-grid.horizontal-list {
          display: flex;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-snap-type: x mandatory;
          scrollbar-width: none; /* Hide scrollbar in Firefox */
          padding-bottom: 1rem;
        }

        .menu-grid.horizontal-list::-webkit-scrollbar {
          display: none; /* Hide scrollbar in Chrome, Safari, and Edge */
        }

        .menu-grid.horizontal-list .menu-card {
          scroll-snap-align: start;
          width: 300px; /* Adjust width as needed */
          flex: 0 0 auto; /* Prevent shrinking */
          margin-right: 1rem; /* Spacing between cards */
        }

        /* Larger screens: Categories vertical, Items horizontal */
        @media (min-width: 769px) {
          .category-list {
            flex: 0 0 200px; /* Fixed width for category list */
            margin-right: 2rem;
          }

          .category-list.horizontal-scroll {
            display: none; /* Hide horizontal list on larger screens */
          }

          .menu-grid {
            flex: 1; /* Take remaining space */
            grid-template-columns: repeat(
              auto-fit,
              minmax(300px, 1fr)
            ); /* responsive grid */
          }

          .menu-grid.vertical-list {
            display: none; /* Hide vertical grid on larger screens */
          }

          .menu-grid.horizontal-list {
            display: grid; /* Display as a grid on larger screens */
            grid-template-columns: repeat(
              auto-fit,
              minmax(300px, 1fr)
            ); /* responsive grid */
            gap: 1.5rem; /* Restore gap between items */
            overflow-x: visible; /* Allow content to wrap */
            overflow-y: visible;
            scroll-snap-type: none; /* Remove scroll snapping */
          }

          .menu-grid.horizontal-list::-webkit-scrollbar {
            display: none; /* Hide scrollbar in Chrome, Safari, and Edge */
          }

          .menu-grid.horizontal-list .menu-card {
            scroll-snap-align: none; /* Disable scroll snapping */
            width: auto; /* Adjust width as needed */
            flex: 0 0 auto; /* Prevent shrinking */
            margin-right: 0; /* Spacing between cards */
            margin-bottom: 1rem;
          }
        }

        .menu-card {
          position: relative;
          border-radius: 0.75rem;
          overflow: hidden;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
            0 2px 4px -1px rgba(0, 0, 0, 0.06);
          transition: all 0.3s ease-in-out;
          width: 100%; /* Adjust as needed */
          margin-bottom: 1rem; /* Spacing between cards */
        }

        .menu-card:hover {
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -2px rgba(0, 0, 0, 0.05);
          transform: scale(1.02);
        }

        .menu-card-image {
          width: 100%;
          height: 200px; /* Adjusted height for smaller cards */
          object-fit: cover;
        }

        .menu-card-details {
          padding: 1rem;
          background-color: #fff;
        }

        .food-title {
          font-size: 1.1rem;
          font-weight: bold;
          margin-bottom: 0.25rem;
        }

        .food-price {
          font-size: 1rem;
          color: #f97316;
          font-weight: bold;
        }

        .add-to-cart {
          position: absolute;
          top: 0.5rem;
          right: 0.5rem;
          background-color: #ef4444;
          color: #fff;
          padding: 0.5rem 1rem;
          border-radius: 9999px;
          border: none;
          cursor: pointer;
          transition: background-color 0.2s ease-in-out;
        }

        .add-to-cart:hover {
          background-color: #dc2626;
        }

        .floating-cart {
          position: fixed;
          bottom: 1.5rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 40;
        }

        .floating-cart .cart-button {
          background-color: #000;
          color: #fff;
          padding: 0.75rem 1.5rem;
          border-radius: 9999px;
          font-weight: 500;
          transition: background-color 0.2s ease;
          border: none;
          cursor: pointer;
        }

        .floating-cart .cart-button:hover {
          background-color: #374151;
        }

        .footer {
          background-color: #f9fafb;
          padding: 3rem 0;
          margin-top: 4rem;
        }

        .footer .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          gap: 2rem;
        }

        @media (min-width: 768px) {
          .footer-content {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        .footer-section {
          display: flex;
          flex-direction: column;
        }

        .footer-title {
          font-size: 1.25rem;
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .footer-links {
          list-style: none;
          padding: 0;
        }

        .footer-links li {
          margin-bottom: 0.5rem;
        }

        .footer-link {
          color: #4b5563;
          cursor: pointer;
          transition: color 0.2s ease;
        }

        .footer-link:hover {
          color: #6b7280;
        }

        .social-icons {
          display: flex;
          gap: 1rem;
        }

        .social-icons i {
          font-size: 1.5rem;
          color: #4b5563;
          cursor: pointer;
          transition: color 0.2s ease;
        }

        .social-icons i:hover {
          color: #6b7280;
        }

        .contact-info {
          display: flex;
          flex-direction: column;
        }

        .contact-details {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 0.5rem;
          color: #4b5563;
        }
      `}</style>
    </div>
  );
};

export default BoulangerieItems;
